import type {
  ContactFeedbackRequest,
  ContactFeedbackResponse,
} from "./types/contact-feedback";

import { apiPost } from "@homeinstead/shared/outbound";
import {
  getMarketingApiConfig,
  MARKETING_API_KEY_HEADER,
} from "./get-marketing-api-config";

const CONTACT_FEEDBACK_PATH = "/api/v1/contact/feedback";

async function postContactFeedback(
  body: ContactFeedbackRequest,
): Promise<ContactFeedbackResponse> {
  const { apiKey, url } = getMarketingApiConfig();

  return apiPost<ContactFeedbackResponse>(
    `${url}${CONTACT_FEEDBACK_PATH}`,
    {
      body: JSON.stringify(body),
      headers: {
        [MARKETING_API_KEY_HEADER]: apiKey,
      },
    },
    {},
  );
}

export { postContactFeedback };
